import {DocumentStore} from '@/components/document/store';
import {INITIAL_SECTION} from '@/constants/sections';
import {DocumentModel, ValueResolver} from '@/engine';
import {ValidateSectionMode} from '@/types/document/store';

const validateMode = ValidateSectionMode.OnlyTouchedFields;

type FoundSections = {
  firstInvalid?: string;
  lastVisible?: string;
};

export const getInitialSection = (documentModel: DocumentModel, state: DocumentStore, valueResolver: ValueResolver) => {
  const {firstInvalid, lastVisible} = documentModel.sections.reduce<FoundSections>(
    (acc, {hidden, visible, id: sectionId}) => {
      if (hidden || !visible || acc.firstInvalid) return acc;

      const sectionIsValid = state.validateSection(sectionId, {documentModel, valueResolver, validateMode});

      return sectionIsValid ? {...acc, lastVisible: sectionId} : {...acc, firstInvalid: sectionId};
    },
    {},
  );

  return firstInvalid ?? lastVisible ?? INITIAL_SECTION;
};
